export type BriefingPeriod = 'morning' | 'midday' | 'evening';

export type BriefingStatus = 'completed' | 'current' | 'upcoming';

export interface MarketBriefingPeriod {
  id: BriefingPeriod;
  icon: string;
  name: string;
  tagline: string;
  timeRange: string;
  status: BriefingStatus;
}

export const BRIEFING_PERIODS: MarketBriefingPeriod[] = [
  {
    id: 'morning',
    icon: '☕',
    name: 'Morning Joe',
    tagline: '"Wake up to what moves markets"',
    timeRange: 'Before 9:30 AM EST',
    status: 'completed'
  },
  {
    id: 'midday',
    icon: '🚀',
    name: 'Midday Madness',
    tagline: '"Catch the momentum shift"',
    timeRange: 'After 11:30 AM EST',
    status: 'current'
  },
  {
    id: 'evening',
    icon: '✨',
    name: 'Evening Glory',
    tagline: '"Close strong, prep for tomorrow"',
    timeRange: 'After 4:00 PM EST',
    status: 'upcoming'
  }
];

export function getCurrentPeriodStatus(): Map<BriefingPeriod, BriefingStatus> {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const currentTime = hours * 60 + minutes;

  // Time ranges in minutes from midnight
  const morningStart = 6 * 60;       // 6:00 AM
  const morningEnd = 9 * 60 + 30;    // 9:30 AM
  const middayStart = 11 * 60 + 30;  // 11:30 AM
  const middayEnd = 13 * 60;         // 1:00 PM
  const eveningStart = 16 * 60;      // 4:00 PM
  const eveningEnd = 18 * 60;        // 6:00 PM

  const statusMap = new Map<BriefingPeriod, BriefingStatus>();

  // Morning status
  if (currentTime >= morningStart && currentTime < morningEnd) {
    statusMap.set('morning', 'current');
  } else if (currentTime >= morningEnd) {
    statusMap.set('morning', 'completed');
  } else {
    statusMap.set('morning', 'upcoming');
  }

  // Midday status
  if (currentTime >= middayStart && currentTime < middayEnd) {
    statusMap.set('midday', 'current');
  } else if (currentTime >= middayEnd) {
    statusMap.set('midday', 'completed');
  } else {
    statusMap.set('midday', 'upcoming');
  }

  // Evening status
  if (currentTime >= eveningStart && currentTime < eveningEnd) {
    statusMap.set('evening', 'current');
  } else if (currentTime >= eveningEnd) {
    statusMap.set('evening', 'completed');
  } else {
    statusMap.set('evening', 'upcoming');
  }

  return statusMap;
}
